module.exports = __webpack_public_path__ + "static/media/Pricedown.96c342ee.ttf";